/**makeSelectLogs
 * Combine all reducers in this file and export the combined reducers.
 */

import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';
import history from '../utils/history';

import {State as LoginState} from '../pages/login/interfaces';
import {State as OrderState} from '../pages/orders/interfaces';
// import {State as FleetState} from '../pages/fleets/interfaces';
import {State as BundleState} from '../pages/bundles/interfaces';
// import {State as DriverState} from '../pages/drivers/interfaces';
// import {State as UserState} from '../pages/users/interfaces';
// import {State as PartnersState} from '../pages/partners/interfaces';
// import {State as CentersState} from '../pages/centers/interfaces';
// import {State as ProductsState} from '../pages/products/interfaces';
import {State as WarehousesState} from '../pages/warehouses/interfaces';
// import {State as ReportsState} from '../pages/reports/interfaces';
import {State as ParcelsState} from '../pages/parcels/parcelsSaga/interfaces';
// import {State as WebhooksState} from '../pages/webhooks/interfaces';
// import {State as WarehouseZonesState} from '../pages/warehouseZones/interfaces';
// import {State as WarehouseZoneAislesState} from '../pages/warehouseZone-aisles/interfaces';
// import {State as WarehouseZoneColumnsState} from '../pages/warehouseZone-column/interfaces';
// import {State as WarehouseZoneRowsState} from '../pages/warehouseZone-row/interfaces';
import {State as WarehouseZoneUnitsState} from '../pages/warehouseZone-unit/interfaces';
// import {State as ProvidersState} from '../pages/providers/interfaces';
// import {State as SellersState} from '../pages/sellers/interfaces';

import LoginReducer from '../pages/login/reducer';
import OrdersReducer from '../pages/orders/reducer';
import BundlesReducer from '../pages/bundles/reducer';
import DriversReducer from '../pages/drivers/reducer';
// import UsersReducer from '../pages/users/reducer';
// import PartnersReducer from '../pages/partners/reducer';
// import CentersReducer from '../pages/centers/reducer';
// import ProductsReducer from '../pages/products/reducer';
import WarehousesReducer from '../pages/warehouses/reducer';
// import ReportsReducer from '../pages/reports/reducer';
import ParcelsReducer from '../pages/parcels/parcelsSaga/reducer';
// import WarehouseZoneReducer from '../pages/warehouseZones/reducer';
// import WarehouseZoneAisleReducer from '../pages/warehouseZone-aisles/reducer';
// import WarehouseZoneColumnReducer from '../pages/warehouseZone-column/reducer';
// import WarehouseZoneRowReducer from '../pages/warehouseZone-row/reducer';
import WarehouseZoneUnitReducer from '../pages/warehouseZone-unit/reducer';
// import WebhooksReducer from '../pages/webhooks/reducer';
// import ProviderReducer from '../pages/providers/reducers';
// import SellerReducer from '../pages/sellers/reducers';
// import FleetsReducer from '../pages/fleets/reducer';

export interface Store {
  login: LoginState;
  orders: OrderState;
  // fleets: FleetState;
  bundles: BundleState;
  // drivers: DriverState;
  // users: UserState;
  // partners: PartnersState;
  // centers: CentersState;
  // products: ProductsState;
  warehouses: WarehousesState;
  // warehouseZones: WarehouseZonesState;
  // warehouseZoneAisles: WarehouseZoneAislesState;
  // warehouseZoneColumns: WarehouseZoneColumnsState;
  // warehouseZoneRows: WarehouseZoneRowsState;
  warehouseZoneUnits: WarehouseZoneUnitsState;
  // reports: ReportsState;
  parcels: ParcelsState;
  // webhooks: WebhooksState;
  // providers: ProvidersState;
  // sellers: SellersState;
  router: any;
}

export default combineReducers<Store>({
  login: LoginReducer,
  orders: OrdersReducer,
  // warehouses: WarehousesReducer,
  // warehouseZoneUnits: WarehouseZoneUnitReducer,
  parcels: ParcelsReducer,
  router: connectRouter(history),





  // fleets: FleetsReducer,
  bundles: BundlesReducer,
  drivers: DriversReducer
  // users: UsersReducer,
  // partners: PartnersReducer,
  // centers: CentersReducer,
  // products: ProductsReducer,
  // warehouseZones: WarehouseZoneReducer,
  // warehouseZoneAisles: WarehouseZoneAisleReducer,
  // warehouseZoneColumns: WarehouseZoneColumnReducer,
  // warehouseZoneRows: WarehouseZoneRowReducer,
  // webhooks: WebhooksReducer,
  // reports: ReportsReducer,
  // providers: ProviderReducer,
  // sellers: SellerReducer,
});
